export default "__VITE_ASSET__$w88rERn__"